// GA4 destination for this build; independent of API/environment configuration.
export const analytics = {
  enabled: true,
  measurementId: 'G-7JBVG7E0DK',
  productId: 'recruitment',
  appVariant: 'default',
  environment: 'dev',
};
